export const productNameTransform = (name?: string | null): string => {
    if (!name) return "";

    return name
        .toLowerCase()
        .replace(/ecco/g, "ECCO")
        .replace(/(^|[\s-])([a-z])/g, (_, sep, char) => sep + char.toUpperCase());
};

export const getImageAltTag = (altTagPattern?: string, imageLabel?: string) => {
    if (!imageLabel) return altTagPattern;
    const imageAlt = imageLabel.charAt(0).toUpperCase() + imageLabel.slice(1);
    return `${altTagPattern} - ${imageAlt}`;
};
